import AjaxCommons from '@/services/ajax-commons';

export interface Image {
  url: string;
  name: string;
}

class GalleryApiAgentImpl {
  constructor(private ajax = AjaxCommons) {}

  public getAll: () => Promise<string[]> = () => {
    return this.ajax.get('type=gallery');
  }

  public add: (name: string) => Promise<void> = (name) => {
    return this.ajax.post(`type=gallery`, {
      name,
    }, 'put');
  }

  public remove: (name: string) => Promise<void> = (name) => {
    return this.ajax.post(`type=gallery`, {
      name,
    }, 'delete');
  }

  public removeImage: (folder: string, img: string) => Promise<void> = (folder, img) => {
    return this.ajax.post(`type=gallery`, {
      folder, img,
    }, 'delete');
  }

  public update: (oldName: string, newName: string) => Promise<boolean> = (oldName, newName) => {
    return this.ajax.post(`type=gallery`, {
      old: oldName,
      new: newName,
    }, 'put');
  }

  public list: (folder: string) => Promise<Image[]> = (folder) => {
    return new Promise((res, rej) => {
      this.ajax.get(`type=gallery&name=${folder}`).then((images: string[]) => {
        res(images.map(img => ({
          url: this.ajax.getGalleryUrl() + folder + '/' + img,
          name: img,
        })));
      })
      .catch(rej);
    });
  }

  public upload: (folder: string, files: FormData) => Promise<Response> = (folder, files) => {
    return this.ajax.file('type=gallery&folder=' + folder, files);
  }
}

const GalleryApiAgent = new GalleryApiAgentImpl();

export default GalleryApiAgent;
export { GalleryApiAgentImpl };
